import script from "./BaseIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseIconButton.vue?vue&type=style&index=0&id=33ea1698&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ea1698"]])

export default __exports__